import { render, staticRenderFns } from "./SystemIcons.vue?vue&type=template&id=cb7c8ff6&scoped=true"
import script from "./SystemIcons.vue?vue&type=script&lang=js"
export * from "./SystemIcons.vue?vue&type=script&lang=js"
import style0 from "./SystemIcons.vue?vue&type=style&index=0&id=cb7c8ff6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7c8ff6",
  null
  
)

export default component.exports